module.exports = __webpack_public_path__ + "img/icon_user_xiugaimima.46ba7361.png";